import { Drawer } from "melco-ui";
import { Drawer as DrawerType } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DesignReferencesList } from "./DesignReferencesList";

type DesignReferencesDrawerProps = {
  drawer: DrawerType;
  id: string;
};

export const DesignReferencesDrawer: React.FC<DesignReferencesDrawerProps> = ({
  drawer,
  id: designId,
}) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("designs.actions.references.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <DesignReferencesList designId={designId} />
    </Drawer>
  );
};
